import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { LOGO_URL, CONTACT, NAV_ITEMS } from "../data/mock";

export default function Footer() {
  return (
    <footer className="bg-[#06143d] text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-xl bg-white p-1.5 flex items-center justify-center">
                <img src={LOGO_URL} alt="ACDT" className="h-full w-full object-contain" />
              </div>
              <div className="leading-tight">
                <div className="text-white font-extrabold tracking-wide">A.C.D.T.</div>
                <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                  Associazione Digitale
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-md">
              {CONTACT.org}. Promuoviamo la formazione certificata di Consulenti e Consumatori
              Digitali, Tecnologici e di Sostenibilità.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={CONTACT.whatsappChannel}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                className="h-9 w-9 rounded-lg bg-white/5 hover:bg-[#25D366] hover:text-white text-slate-300 flex items-center justify-center transition-colors"
                aria-label="Canale WhatsApp"
              >
                <Globe className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-white font-bold mb-4">Naviga</div>
            <ul className="space-y-2.5 text-sm">
              {NAV_ITEMS.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="hover:text-[#fbbf24] transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-white font-bold mb-4">Contatti</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-[#f59e0b]" />
                <span>{CONTACT.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#f59e0b]" />
                <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-[#fbbf24]">{CONTACT.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 text-[#f59e0b]" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-[#fbbf24] break-all">{CONTACT.email}</a>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="h-4 w-4 text-[#f59e0b]" />
                <a href={`https://${CONTACT.website}`} target="_blank" rel="noreferrer" className="hover:text-[#fbbf24]">{CONTACT.website}</a>
              </li>
            </ul>
            <div className="mt-5 pt-4 border-t border-white/10 grid grid-cols-2 gap-3 text-xs">
              <div>
                <div className="text-slate-500 uppercase tracking-wider">C.F.</div>
                <div className="text-slate-200 font-semibold">{CONTACT.cf}</div>
              </div>
              <div>
                <div className="text-slate-500 uppercase tracking-wider">P.IVA</div>
                <div className="text-slate-200 font-semibold">{CONTACT.piva}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row gap-3 items-center justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} A.C.D.T. – Tutti i diritti riservati.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy-policy" className="hover:text-[#fbbf24]">Privacy Policy</Link>
            <Link to="/cookie-policy" className="hover:text-[#fbbf24]">Cookie Policy</Link>
            <Link to="/termini-e-condizioni" className="hover:text-[#fbbf24]">Termini & Condizioni</Link>
            <Link to="/note-legali" className="hover:text-[#fbbf24]">Note Legali</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
